<template>
  <div>

    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader class="p-1">
            <CRow>
              <CCol col="8" style="text-align: start ;padding:10px 20px 0 20px ">
                <strong>{{$t('weekDays')}}</strong>

              </CCol>
              <CCol col="4" style="text-align: end">
                <CButton
                    class="mr-1"
                    size="sm"
                    color="secondary"
                >{{ $t("buttons.print") }}
                </CButton>

              </CCol>
            </CRow>

          </CCardHeader>

          <CCardBody>
            <CRow>
              <CCol col="3">
                <treeselect
                    v-model="PersonId"
                    :async="true"
                    :load-options="load_persons"
                    :placeholder="$t('components.searchUser')"
                    :normalizer="normalizer_persons"
                />
              </CCol>
              <CCol col="3">
                <CRow form class="form-group">
                  <CCol tag="label" sm="3" class="col-form-label">
                    {{$t('date')}}
                  </CCol>
                  <CCol sm="9">
                    <date-picker
                        v-model="start_date"></date-picker>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>

            <CDataTable
                :items="items_worker"
                :fields="fields"
                @row-clicked="table_row_clicked"
                :items-per-page="10"
                hover
                sorter
                border
                striped
                pagination
            >
              <template #row_id="{item,index}">
                <td>
                  <p >{{ index + 1 }}</p>
                </td>
              </template>
              <template #sat="{item}">
                <td>
                  <p v-if="item.sat" >{{ item.sat }}</p>
                </td>
              </template>
              <template #sun="{item}">
                <td>
                  <p v-if="item.sun" >{{ item.sun }}</p>
                </td>
              </template>
              <template #mon="{item}">
                <td>
                  <p v-if="item.mon" >{{ item.mon }}</p>
                </td>
              </template>
              <template #tue="{item}">
                <td>
                  <p v-if="item.tue" >{{ item.tue }}</p>
                </td>
              </template>
              <template #wed="{item}">
                <td>
                  <p v-if="item.wed" >{{ item.wed }}</p>
                </td>
              </template>
              <template #thr="{item}">
                <td>
                  <p v-if="item.thr" >{{ item.thr }}</p>
                </td>
              </template>
              <template #fri="{item}">
                <td>
                  <p v-if="item.fri" >{{ item.fri }}</p>
                </td>
              </template>

              <template #operation="{item,index}">
                <td class="py-2">
                  <CButton
                      class="m-1"
                      color="primary"
                      variant="outline"
                      square
                      :title="$t('buttons.edit')"
                      size="sm"
                      @click="goEditPerson(item)"
                  >
                    <CIcon name="cil-pencil"/>
                  </CButton>

                </td>
              </template>


            </CDataTable>


          </CCardBody>

        </CCard>
      </CCol>
    </CRow>
    <CModal
        :show.sync="change_status_modal"
        :no-close-on-backdrop="true"
        color="dark"
        size="lg"
        :title="selected_reminder.title"
    >

      <CRow>
<!--        <CCol col="3">-->
<!--         <label>نوع : {{selected_reminder.reminderTypeTitle}}</label>-->
<!--        </CCol>-->
        <CCol col="3">
         <label>{{$t('tables.category')}} : {{selected_reminder.categoryTitle}}</label>
        </CCol>
        <CCol col="3">
         <label>{{$t('priority')}} : {{selected_reminder.priorityTitle}}</label>
        </CCol>
        <CCol col="3">
         <label>{{$t('tables.status')}} : {{selected_reminder.statusTitle}}</label>
        </CCol>
        <CCol col="3">
          <label>{{$t('startDate')}} : {{get_date(selected_reminder.startDate)}}</label>
        </CCol>
        <CCol col="3">
          <label>{{$t('startTime')}}: {{selected_reminder.startTime}}</label>
        </CCol>
        <CCol col="3">
          <label>{{$t('alarmDate')}} : {{get_date(selected_reminder.alarmDate)}}</label>
        </CCol>
        <CCol col="3">
          <label>{{$t('alarmTime')}} : {{selected_reminder.alarmTime}}</label>
        </CCol>
        <CCol col="3">
          <label>{{$t('repeat')}} : {{selected_reminder.repeatTitle }}</label>
        </CCol>

      </CRow>

      <CRow>
        <CCol col="12" v-if="selected_reminder.repeat != 0 && selected_reminder.repeat != null">
          <hr>
<CRow>
          <CCol v-if="selected_reminder.days.filter(x => x.dayId==0).length"> {{$t('saturday')}}  </CCol>
          <CCol v-if="selected_reminder.days.filter(x => x.dayId==1).length"> {{$t('sunday')}} </CCol>
          <CCol v-if="selected_reminder.days.filter(x => x.dayId==2).length"> {{$t('monday')}}  </CCol>
          <CCol v-if="selected_reminder.days.filter(x => x.dayId==3).length">  {{$t('tuesday')}}  </CCol>
          <CCol v-if="selected_reminder.days.filter(x => x.dayId==4).length">{{$t('wednesday')}}  </CCol>
          <CCol v-if="selected_reminder.days.filter(x => x.dayId==5).length">{{$t('thursday')}}  </CCol>
          <CCol v-if="selected_reminder.days.filter(x => x.dayId==6).length">{{$t('friday')}}  </CCol>
</CRow>
 <hr>
        </CCol>
      </CRow>
      <CRow>
        <CCol col="12">
          <label>{{ selected_reminder.note }}</label>
        </CCol>

      </CRow>
      <template #footer>

        <CButton
            @click="change_status_modal = false"
            color="dark"
        >{{ $t("buttons.close") }}
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
import moment from 'moment-jalaali'
import i18n from "@/i18n";

var simulateAsync=null
    const simulateAsyncOperation = fn => {
        if(simulateAsync!=null){
            clearTimeout(simulateAsync)
        }
        simulateAsync =  setTimeout(fn, 1000)
    }
var items_data = [];

import Vue from 'vue'
export default {
  name: 'Login',
  components: {Treeselect},

  data() {
    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      name: '',
      file: '',
      PersonId: null,
      change_status_modal:false,
      selected_reminder:{},
      color: '#ffffff',
      previewImage: '',
      selected_template: 0,
      description: '',
      saleMethodModal: false,
      method_list: [],
      selected_method: '',
      selected_exist: 0,
      selected_person: 0,
      selected_status: 0,
      start_date:'',
      items_customer: [],
      fields: [
        {key: 'row_id', label: this.$t('tables.row'),sorter:false, _style: 'width:3%'},
        {key: 'sat', label: this.$t('saturday'), _style: 'width:10%'},
        {key: 'sun', label: this.$t('sunday'), _style: 'width:10%'},
        {key: 'mon', label: this.$t('monday'), _style: 'width:10%'},
        {key: 'tue', label: this.$t('tuesday'), _style: 'width:10%'},
        {key: 'wed', label: this.$t('wednesday'), _style: 'width:10%'},
        {key: 'thr', label: this.$t('thursday'), _style: 'width:10%'},
        {key: 'fri', label: this.$t('friday'), _style: 'width:10%'},
      ],

      items_worker: [],
      // fields,

      items_vendor: [],
      // fields,

      details: [],

      collapseDuration: 0,
      status_form: 0,
      table_clicks: 0,

      load_persons({action, searchQuery, callback}) {

        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options;
            const formData = new FormData();

            formData.append('SearchTxt', searchQuery);
            var url = "GetAllPersons";

            formData.append('IsVendor', true);
            formData.append('IsWorker', false);
            formData.append('IsCustomer', false);
            formData.append('IsActive', 0);

            axios.post(url, formData, {show_pros: true}).then(function (response) {
              options = response.data.data;

              callback(null, options);

            })
                .catch(function (error) {

                  console.log(error);
                });

          })
        }
      },
      normalizer_persons(node) {
        return {
          id: node.userId,
          label: node.personCode + " " + node.userName + " " + node.surName + " " + node.mobileNo,
        }
      },
      table_clicks_timer: null,
    }
  }, mounted() {
    this.start_date = this.get_today()
    if (i18n.locale == "en") {
      this.fields = [
        {key: 'row_id', label: this.$t('tables.row'),sorter:false, _style: 'width:3%'},
        {key: 'sun', label: "Sunday", _style: 'width:10%'},
        {key: 'mon', label: "Monday", _style: 'width:10%'},
        {key: 'tue', label: "سه شنبه", _style: 'width:10%'},
        {key: 'wed', label: "چهارشنبه", _style: 'width:10%'},
        {key: 'thr', label: "پنجشنبه", _style: 'width:10%'},
        {key: 'fri', label: "جمعه", _style: 'width:10%'},
        {key: 'sat', label: "شنبه", _style: 'width:10%'},

      ];
    }
    this.$root.root_validate_errors = [];
    this.get_lists();
    bus.$on('update_reminder', (data) => {
      this.get_lists()
    });
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    'start_date': function () {
      this.get_lists();
    },
    'PersonId': function () {
      this.get_lists();
    }
  },
  beforeDestroy() {
    console.log("before desroy called")
    bus.$off()
  },
  methods: {
    table_row_clicked(item, index,column) {

     console.log(column,item[column+"_data"])
      this.change_status_modal = true;
     this.selected_reminder = item[column+"_data"];
    },


    get_lists() {
      var self = this;


      const formData = new FormData();

      var url = "GetUserReminderList";
      if (this.PersonId == null) {
        formData.append('Id', 0);

      } else {
        formData.append('Id', this.PersonId);

      }

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          // self.items_worker = content_data.data;
          var first_week_date = '';
          var items_data = [];
            first_week_date = moment(self.start_date,'YYYY-MM-DD').locale(i18n.locale).startOf('week');

          first_week_date.locale(i18n.locale).subtract(1, 'day');
          for (var i = 1; i <= 7; i++) {
            var day_of_week = first_week_date.locale(i18n.locale).add(1, 'day');
            // console.log("way of week", i, day_of_week);
            if(day_of_week.isSame(moment(self.get_today(),'YYYY-MM-DD').locale(i18n.locale), "week")){
              if (day_of_week.isSame(moment(self.get_today(),'YYYY-MM-DD').locale(i18n.locale), "day")) {
                Vue.set(self.fields[i],"_classes" , 'bg-dark');
              }else{
                Vue.set(self.fields[i],"_classes" , '');
              }
            }else{

              if (day_of_week.isSame(moment(self.start_date,'YYYY-MM-DD').locale(i18n.locale), "day")) {
                Vue.set(self.fields[i],"_classes" , 'bg-dark');
              }else{
                Vue.set(self.fields[i],"_classes" , '');
              }
            }

            switch (i){
              case 1:
                self.fields[i].label=self.$t('saturday')+" \n" + self.get_date(first_week_date);
                break;case 2:
                self.fields[i].label=self.$t('sunday')+" \n" + self.get_date(first_week_date);
                break;case 3:
                self.fields[i].label=self.$t('monday')+" \n" + self.get_date(first_week_date);
                break;case 4:
                self.fields[i].label=self.$t('tuesday')+" \n" + self.get_date(first_week_date);
                break;case 5:
                self.fields[i].label=self.$t('wednesday')+" \n" + self.get_date(first_week_date);
                break;case 6:
                self.fields[i].label=self.$t('thursday')+" \n" + self.get_date(first_week_date);
                break;case 7:
                self.fields[i].label=self.$t('friday')+" \n" + self.get_date(first_week_date);
                break;
            }
            var filter_date = content_data.data.filter(x =>
                moment(x.alarmDate).isSame(day_of_week, 'day'));
            for (var z = 0; z < filter_date.length; z++) {
              if (items_data[z] == null) {
                items_data[z] = {};
              }
              if (items_data[z][self.fields[i].key] == null) {
                // items_data[z][self.fields[i].key] = filter_date[z].reminderTypeTitle+": "+filter_date[z].title+" "+filter_date[z].startTime;
                items_data[z][self.fields[i].key] = filter_date[z].title+" "+filter_date[z].startTime;
                items_data[z][self.fields[i].key+"_data"] = filter_date[z];
              } else {
                // items_data[z + 1][self.fields[i].key] = filter_date[z+1].reminderTypeTitle+": "+filter_date[z+1].title+" "+filter_date[z+1].startTime;
                items_data[z + 1][self.fields[i].key] = filter_date[z+1].title+" "+filter_date[z+1].startTime;
                items_data[z+1][self.fields[i].key+"_data"] = filter_date[z+1];
              }
            }
            self.items_worker = items_data;
            // console.log(moment(content_data.data[0].alarmDate));
            // console.log(moment());

            // filter_date.forEach((val) => {
            //   console.log("day", val, i);
            //
            // });
          }
          console.log(self.items_worker);


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    goEditPerson(item) {

      this.$router.push({path: '/dashboard/users/edit-user/' + item.userId});

    },

    delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = this.items[item.row_id].id;

    },
    delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeletePerson";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {

          self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        self.get_lists();

      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
  }
}

</script>
